import type { SVGProps } from "react";
export interface FlowerPlantIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function FlowerPlantIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: FlowerPlantIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.875 12a1.125 1.125 0 1 1 2.25 0v4.021a6.7 6.7 0 0 1 1.368-1.327c1.937-1.391 4.498-1.592 7.692-1.056.542.09.94.56.94 1.109 0 3.237-1.044 5.673-3.19 7.076-2.034 1.33-4.807 1.555-7.936 1.053-3.128.501-5.9.277-7.934-1.053C1.92 20.42.875 17.985.875 14.747c0-.55.397-1.018.939-1.11 3.195-.535 5.755-.334 7.692 1.057a6.7 6.7 0 0 1 1.37 1.327V12Zm-2.682 4.52c-1.068-.767-2.614-1.088-5.03-.804.181 2.167.986 3.475 2.133 4.225 1.187.776 2.952 1.097 5.322.851-.59-2.198-1.38-3.521-2.425-4.272m12.642-.804c-2.415-.284-3.961.038-5.029.804-1.045.751-1.837 2.074-2.426 4.272 2.37.246 4.136-.075 5.323-.851 1.147-.75 1.95-2.058 2.132-4.225"
      />
      <path
        fill={color}
        d="M12.001.875c1.523 0 2.84.955 3.356 2.323a3.59 3.59 0 0 1 3.249 2.476 3.59 3.59 0 0 1-1.173 3.911 3.59 3.59 0 0 1-1.35 3.854 3.59 3.59 0 0 1-4.083.092 3.588 3.588 0 0 1-5.434-3.946 3.59 3.59 0 0 1-1.171-3.911 3.59 3.59 0 0 1 3.247-2.476A3.59 3.59 0 0 1 12.001.875m0 2.25a1.34 1.34 0 0 0-1.314 1.074l-.02.124-.022.211a1.125 1.125 0 0 1-1.351.982l-.207-.044a1.342 1.342 0 0 0-.824 2.535l.193.087a1.125 1.125 0 0 1 .516 1.588l-.106.183a1.342 1.342 0 0 0 2.158 1.567l.14-.157.085-.083a1.126 1.126 0 0 1 1.587.083l.14.157.091.09a1.34 1.34 0 0 0 2.126-1.543l-.059-.114-.105-.183a1.125 1.125 0 0 1 .515-1.588l.194-.087.114-.057a1.34 1.34 0 0 0-.813-2.499l-.124.02-.208.045a1.125 1.125 0 0 1-1.351-.982l-.022-.21a1.34 1.34 0 0 0-1.333-1.199M11.5 7.429a.62.62 0 0 0-.124.372l.013.124a.6.6 0 0 0 .111.245zm1 .74a.6.6 0 0 0 .112-.244l.013-.124-.013-.126a.6.6 0 0 0-.111-.246zm1.126-.368a1.626 1.626 0 0 1-3.242.165l-.009-.165.009-.167a1.625 1.625 0 0 1 1.615-1.46l.167.01c.82.083 1.46.775 1.46 1.617"
      />
    </svg>
  );
}
